import { FC, useState } from "react";
import { UploadIco } from "../../assets/customIcons";
import classnames from "classnames";
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import styles from "./FileField.module.scss";
import { checkFileTypes, fileTypes } from "../../utils/helpers/file.helpers";
import { observer } from "mobx-react-lite";

interface IFileField {
  label?: string;
  showLabel?: boolean;
  className?: string;
  isDisabled?: boolean;
  onChange?: (e: FileList) => void;
  disabled?: boolean;
  required?: boolean;
  accept?: string;
  multiple?: boolean;
  error?: FieldError | string | Merge<FieldError, FieldErrorsImpl<any>>;
}

const FileField: FC<IFileField> = (
  {
    label,
    showLabel = true,
    className,
    isDisabled,
    onChange,
    disabled,
    error,
    required = false,
    accept = "",
    multiple = false,
  },
  ref,
) => {
  const [value, setValue] = useState(null);
  const onFileChange = (e) => {
    const files = Object.values(fileTypes).includes(accept)
      ? Array.from(e.target.files)?.filter(({ type }: { type: string }) =>
          checkFileTypes(fileTypes.xls, type),
        )
      : e.target.files;
    if (typeof onChange === "function") {
      onChange(files);
    }
    e.target.value = null;
    setValue(e.target.files);
  };

  return (
    <label
      title={label}
      className={classnames(styles.fileField, {
        [className]: className,
        [styles.disabled]: isDisabled,
        [styles.error]: error && !value,
      })}
    >
      <input
        className={classnames(className, {
          [styles.error]: error,
        })}
        type="file"
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        accept={accept}
        multiple={multiple}
        onChange={(e) => onFileChange(e)}
        ref={ref}
      />

      <UploadIco />
      {showLabel && label && (
        <span className={styles.fileFieldLabel}>
          {label}
          {!disabled && required && <span className={styles.required}>*</span>}
        </span>
      )}
      {error && !value && <div className={styles.errorMessage}>{error}</div>}
    </label>
  );
};

export default observer(FileField, { forwardRef: true });
